import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { toast } from 'react-toastify'
import {
  ICreateBlastWindowRequest,
  IOperationsEnvironResponse,
} from 'types/api/operationsAimApi.interface'
import { IOpsEnvironSlice } from 'types/opsEnviron.interface'
import { baseUrl } from 'utils/axios'
import { handleErrors } from 'utils/helpers'
import { mapEnviron } from 'pages/Operations/Shared/opsApiMappers'
import { USE_OPS_MOCKS } from 'pages/Operations/Shared/opsControl'
import { demoEnviron } from 'pages/Operations/Shared/opsApiDemoCore'

const initialState: IOpsEnvironSlice = {
  isLoading: false,
  environ: null,
}

export const getOpsEnviron = createAsyncThunk(
  'opsEnviron/getOpsEnviron',
  async (_, thunkAPI) => {
    if (USE_OPS_MOCKS) return mapEnviron(demoEnviron(), {})
    try {
      const resp: AxiosResponse<IOperationsEnvironResponse> = await baseUrl.get('aim-operations/environ')
      return mapEnviron(resp.data, {})
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
)

export const createBlastWindow = createAsyncThunk(
  'opsEnviron/createBlastWindow',
  async (body: ICreateBlastWindowRequest, thunkAPI) => {
    try {
      await baseUrl.post('aim-operations/blast-window', body)
      toast.success('Blast window created')
      await thunkAPI.dispatch(getOpsEnviron())
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
)

const opsEnvironSlice = createSlice({
  name: 'opsEnviron',
  initialState,
  reducers: {
    clearOpsEnviron: (state) => {
      state.environ = null
    },
  },
  extraReducers: {
    [getOpsEnviron.pending.type]: (state) => {
      state.isLoading = true
    },
    [getOpsEnviron.fulfilled.type]: (state, { payload }) => {
      state.isLoading = false
      state.environ = payload
    },
    [getOpsEnviron.rejected.type]: (state, action) => {
      state.isLoading = false
      handleErrors(action.payload)
    },
    [createBlastWindow.rejected.type]: (state, action) => handleErrors(action.payload),
  },
})

export const { clearOpsEnviron } = opsEnvironSlice.actions
export default opsEnvironSlice.reducer
